import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/wassim/bitcall/bitcall-front/frontend/src/views/front-pages/landing-page/index.tsx");
